
import { defineComponent, ref, reactive, toRefs, computed, nextTick, WritableComputedRef } from 'vue'
import { SearchOutlined, CloseCircleFilled, DeleteOutlined } from '@ant-design/icons-vue'
import nineDirections from '@/api/nineDirections'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { gotoClientLogin } from '@/utils/stock'
const SEARCH_DEBOUNCE = 300
const HISTORY_MAX = 10
const API_CONFIG = {
  appcode: 'com.rjhy.uranus',
  serverId: '200',
  appVersion: '3.15.2',
  clientType: 'ios',
  softName: 'jfztadv'
}

interface pageDataType {
  value: string
  options: any[]
  historyData: any[]
  activeLi?: WritableComputedRef<string>
  activeindex: number
  showDropdown: boolean
  selectOption: any
  errorRequest: boolean
  [propName: string]: any
}
interface EventType extends Event {
  code?: string
}
export default defineComponent({
  name: 'SearchCourse',
  components: {
    SearchOutlined,
    CloseCircleFilled,
    DeleteOutlined
  },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    }
  },
  setup(props: any, content: any) {
    const route = useRoute()
    const pageData: pageDataType = reactive({
      value: '',
      options: [],
      historyData: [],
      activeindex: 0,
      showDropdown: false,
      selectOption: [],
      errorRequest: false
    })
    const askingselect = ref()
    const scrollWrapper = ref()
    pageData.activeLi = computed(() => {
      const item = pageData.selectOption[pageData.activeindex]
      return item?.Id?.toString() ?? ''
    })
    pageData.selectOption = computed(() => {
      if (!pageData.value.length && pageData.historyData.length) {
        return [...pageData.historyData].reverse()
      }
      return pageData.options || []
    })
    
    function handleChange(e: EventType, value: any) {
      if (value.type && value.type === 'notCourseGroup') {
        // 历史记录，非课程且非专题
        pageData.value = value.Id
        searchValue()
        handleHistory(value.Id)
      } else {
        handleHistory(value.Id)
        jumpToDetail(value)
        pageData.value = ''
        searchValue()
        blurSelect(1)
        askingselect.value?.blur()
      }
      e.stopPropagation()
      return false
    }
    let searchTimer: any = null
    function searchValue() {
      if (searchTimer) clearTimeout(searchTimer)
      pageData.activeindex = 0
      nextTick(() => {
        if (scrollWrapper.value) {
          scrollWrapper.value.scrollTop = 0
        }
      })
      if (!pageData.value.trim() || pageData.errorRequest) {
        pageData.options = []
        searchTimer = null
        return
      }
      const keyword = pageData.value.trim()
      searchTimer = setTimeout(() => {
        nineDirections.stockEntrance(
          { types: 'coursePackage', keyword },
          { ...API_CONFIG, token: (route.query.token as string) || '' }
        ).then((res: any) => {
        if (res?.code === 1 && res?.data?.coursePackage) {
          pageData.errorRequest = false
          pageData.options = res.data.coursePackage.map((item: any) => ({
            Id: item.data?.courseNo,
            courseName: item.data?.courseName,
            courseNo: item.data?.courseNo,
            ...item.data
          }))
        } else {
          pageData.options = []
        }
      }).catch(() => {
        pageData.errorRequest = true
        pageData.options = []
      })
      }, SEARCH_DEBOUNCE)
    }

    function focusSelect() {
      if (!pageData.showDropdown) {
        pageData.showDropdown = true
        window.addEventListener('keydown', handlekeyFn, true)
        const history = JSON.parse(sessionStorage.getItem('jfSchoolHistory') || '[]') || []
        pageData.historyData = history.slice(-HISTORY_MAX)
      }
    }
    let blurTimer: ReturnType<typeof setTimeout> | null = null
    function blurSelect(delay?: number) {
      if (blurTimer) clearTimeout(blurTimer)
      blurTimer = setTimeout(() => {
        pageData.showDropdown = false
        window.removeEventListener('keydown', handlekeyFn, true)
        blurTimer = null
      }, delay ?? 200)
    }
    function enterSelect() {
      if (!pageData.activeLi && !pageData.value.length) return
      if (pageData.errorRequest) {
        reRequest()
        return
      }
      const value = pageData.value.trim()
      if ((pageData.activeLi || '').toString() !== '') {
        const currentItem = pageData.selectOption.find((item: any) => item.Id === pageData.activeLi)
        if (!currentItem) return
        handleHistory(pageData.activeLi)
        if (currentItem.type === 'notCourseGroup') {
          pageData.value = currentItem.Id
          searchValue()
        } else {
          jumpToDetail(currentItem)
          pageData.value = ''
          searchValue()
          blurSelect(1)
          askingselect.value?.blur()
        }
      }
    }
    function jumpToDetail(currentItem: any) {
      if (currentItem.courseNo) {
        const query = JSON.parse(JSON.stringify(route.query))
        delete query.groupCode
        if (!route.query.token) {
          gotoClientLogin()
          return
        }
        router.push({
          name: 'coursedetail',
          query: {
            ...query,
            courseNo: currentItem.courseNo,
            lessonNo: null,
            courseType: currentItem.courseType
          },
          params: {
            nogroupName: 'true'
          }
        })
      } else if (currentItem.groupCode) {
        const query = JSON.parse(JSON.stringify(route.query))
        delete query.courseNo
        router.push({
          name: 'specialcourse',
          query: {
            ...query,
            groupCode: currentItem.groupCode,
            groupName: currentItem.groupName
          }
        })
      }
    }
    function handleHistory(id: any) {
      const history = pageData.historyData.filter((item: any) => item.Id !== id)
      const currentItem = pageData.selectOption.find((item: any) => item.Id === id)
      if (currentItem) {
        history.push(currentItem)
      } else {
        history.push({
          groupName: id,
          Id: id,
          type: 'notCourseGroup'
        })
      }
      if (history.length > HISTORY_MAX) {
        history.shift()
      }
      sessionStorage.setItem('jfSchoolHistory', JSON.stringify(history))
      pageData.historyData = history
    }
    function clearHistory() {
      pageData.historyData = []
      sessionStorage.removeItem('jfSchoolHistory')
    }
    function cleartagsCall() {
      pageData.value = ''
      searchValue()
      preventBlur()
    }
    function cancelArrowUp(e: EventType) {
      if (e.code === 'ArrowUp') {
        e.preventDefault()
        return false
      }
    }
    function handlekeyFn(e: EventType) {
      if (e.code !== 'ArrowDown' && e.code !== 'ArrowUp' && e.code !== 'Enter') return
      // 向下箭头
      if (e.code === 'ArrowDown') {
        pageData.activeindex++
        if (pageData.activeindex >= pageData.selectOption.length) {
          pageData.activeindex = pageData.selectOption.length - 1
        }
      } else if (e.code === 'ArrowUp') {
        pageData.activeindex--
        if (pageData.activeindex < 0) {
          pageData.activeindex = 0
        }
      } else if (e.code === 'Enter') {
        enterSelect()
      }
      nextTick(() => {
        if (pageData.activeindex < 7) {
          if (scrollWrapper.value) {
            scrollWrapper.value.scrollTop = 0
          }
        } else {
          if (scrollWrapper.value) {
            scrollWrapper.value.scrollTop = pageData.activeindex * 24 - 140
          }
        }
      })
    }
    function inputKeyup(e: EventType) {
      if (e.code === 'Enter') {
        enterSelect()
      }
    }
    function reRequest() {
      pageData.errorRequest = false
      searchValue()
    }
    function preventBlur() {
      if (blurTimer) {
        clearTimeout(blurTimer)
        blurTimer = null
      }
    }
    function highlightKeywords(str: string, key?: string) {
      if (!key) return str
      const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const match = str.match(new RegExp(escaped, 'i'))?.[0]
      return match ? str.replace(match, `<font style="color: #ff5c5c">${match}</font>`) : str
    }

    return {
      ...toRefs(pageData),
      handleChange,
      searchValue,
      focusSelect,
      clearHistory,
      blurSelect,
      cleartagsCall,
      askingselect,
      enterSelect,
      handlekeyFn,
      inputKeyup,
      scrollWrapper,
      reRequest,
      preventBlur,
      cancelArrowUp,
      highlightKeywords
    }
  }
})
